import React, { useState } from "react";
import themeStyles from "../../../shared/styles/theme/theme-styles.module.scss";
import Form from "../../components/formWrapper/FormWrapper";
import * as Yup from "yup";
import { validateEmail } from "../../../shared/utils/validation";
import InputCheckbox from "../../components/InputCheckbox";
import InputGroup from "../../components/inputGroup/InputGroup";
import "./loginBox.scss";

const LoginBox = (props) => {
  const [isPasswordHidden, setIsPasswordHidden] = useState(true);
  const [loginIn] = useState(false);

  const handleEyeClick = () => {
    setIsPasswordHidden(!isPasswordHidden);
  };

  const { onForgetPasswordClick, errors } = props;

  const loginForm = (props) => {
    const handleOnSelect = () => {
      props.setFieldValue("rememberme", !props.values.rememberme);
    };

    return (
      <form className="loginForm">
        <InputGroup
          id="loginBox_username"
          name="username"
          label={"E-mail"}
          inputValue={props.values.username}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          className="formGroupLogin"
          errors={props.errors}
          touched={props.touched}
        />
        <InputGroup
          id="loginBox_password"
          name="password"
          label={"Password"}
          inputValue={props.values.password}
          inputType={isPasswordHidden ? "password" : "text"}
          showEye
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          onClick={handleEyeClick}
          className="formGroupLogin"
          errors={props.errors}
          touched={props.touched}
        />
        <div className="formGroupLogin signIn">
          <div className={`${themeStyles.textLabelForm} rememberMeCb`}>
            <InputCheckbox
              checked={props.values.rememberme}
              onSelect={handleOnSelect}
              className="rememberCheck"
              background={"#83C517"}
            />
            <label className="rememberMeCbText">Remember Me</label>
          </div>
          <label
            className="rememberMeCbText"
            onClick={onForgetPasswordClick}
            style={{ cursor: "pointer" }}
          >
            Forgot Password?
          </label>
        </div>
        <div className="signIn">
          <button
            type="submit"
            className={themeStyles.btnPrimary}
            onClick={props.handleSubmit}
            disabled={loginIn}
          >
            Sign In
          </button>
        </div>
      </form>
    );
  };

  const { className, title, subtitle, values } = props;
  return (
    <div className={className || ""}>
      <h3 className={themeStyles.headerSmInverted}>{title}</h3>
      <span className="subtitle">{subtitle}</span>
      <Form
        initialValues={values}
        onSubmit={props.onLogin}
        component={loginForm}
        validationSchema={Yup.object().shape({
          username: validateEmail("Invalid Email").required("Required Field"),
          password: Yup.string()
            .required("Field Required")
            .min(8, "password must be at least 8 characters"),
        })}
        errors={errors}
      />
    </div>
  );
};

export default LoginBox;
